import { useMemo } from 'react';
import { hasMaxLength, isNotEmpty, isSelected, isValidMinutes, isValidLatitude, isValidLongitude, isNotEmptyRTE, } from '../../../hooks/formValidator/validators';
import { APP_LANGUAGES } from '../../../app.config.vars/languages';
export const buildInputValidationSchema = (includeMinutes, checkDescriptionTranslations) => {
    const baseSchema = {
        internalTitle: [isNotEmpty, hasMaxLength(250)],
        latitude: [(value) => (value !== '' ? isValidLatitude(value) : null)],
        longitude: [(value) => (value !== '' ? isValidLongitude(value) : null)],
    };
    if (includeMinutes) {
        baseSchema.minutes = [isValidMinutes(3600)];
    }
    APP_LANGUAGES.forEach(({ code }) => {
        baseSchema[`title${code.toUpperCase()}`] = [isNotEmpty, hasMaxLength(250)];
        baseSchema[`description${code.toUpperCase()}`] = checkDescriptionTranslations
            ? [isNotEmptyRTE]
            : [];
    });
    return baseSchema;
};
const useRallyFormValidationSchema = ({ isRallyTimeLimit, }) => {
    const selectsValidationSchema = {
        themes: [isSelected('multiple')],
        targetGroups: [isSelected('multiple')],
    };
    const inputsValidationSchema = useMemo(() => buildInputValidationSchema(isRallyTimeLimit), [isRallyTimeLimit]);
    return { selectsValidationSchema, inputsValidationSchema };
};
export default useRallyFormValidationSchema;
